/**
 * VibeCheck CLI v2 — Interactive Menu
 * Launched when user runs bare `vibecheck` with no arguments.
 */

import { select } from '@inquirer/prompts';
import { colors, icons, brandName } from './theme';

interface MenuChoice {
  name: string;
  value: string;
  description: string;
}

const COMMANDS: MenuChoice[] = [
  { name: `${icons.rocket}  kickoff`,     value: 'kickoff',     description: 'Initialize VibeCheck in your project' },
  { name: `${icons.magnify}  scan`,       value: 'scan',        description: 'Scan codebase for issues (hallucinations, security, quality)' },
  { name: `${icons.ship}  ship`,          value: 'ship',        description: 'Pre-deployment readiness check' },
  { name: `${icons.doctor}  doctor`,      value: 'doctor',      description: 'Diagnose project setup and environment issues' },
  { name: `${icons.target}  missionpack`, value: 'missionpack', description: 'Generate structured task breakdowns' },
  { name: `${icons.globe}  reality`,      value: 'reality',     description: 'Runtime verification with Playwright' },
  { name: `${icons.hammer}  forge`,       value: 'forge',       description: 'Generate code with quality standards baked in' },
  { name: `${icons.polish}  polish`,      value: 'polish',      description: 'Improve existing code quality' },
  { name: `${icons.shield}  firewall`,    value: 'firewall',    description: 'Real-time AI code guardrails' },
  { name: `${icons.book}  docguard`,      value: 'docguard',    description: 'Documentation health and coverage checker' },
];

export async function showInteractiveMenu(): Promise<string> {
  console.log();
  console.log(`  ${brandName()} ${colors.dim('— AI Code Validation Platform')}`);
  console.log(`  ${colors.dim('Catch hallucinations, security issues, and quality problems before they ship.')}`);
  console.log();

  const answer = await select({
    message: 'What would you like to do?',
    choices: COMMANDS.map(cmd => ({
      name: `${cmd.name}  ${colors.dim(cmd.description)}`,
      value: cmd.value,
    })),
  });

  return answer;
}
